<template>
  <div class="homePage">
    <el-carousel>
      <el-carousel-item v-for="(url,index) in pictureList" :key="index">
        <el-image
            class="carousel-img"
            :src="url"
            fit="cover"></el-image>
      </el-carousel-item>
    </el-carousel>

    <div class="chanpin" style="margin-top: 40px">
      <el-row>
        <el-col class="chanpin-left"
                :lg="{span:8,offset:3} " :md="{span:10,offset:6}" :sm="{span:10,offset:7}"
                :xs="{span:16,offset:4}">
          <el-row>
            <el-col>
              <div class="product-main-image-container">
                <img class="product-main-image"
                     :style="{ objectFit: currentImageFit }"
                     :src=currentUrl
                     @load="onMainImageLoad">
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <img style="width:100%;height: 120px" src="@/../static/iamges/home/home_bg_250_80.png">
            </el-col>
          </el-row>
          <el-row style="position: relative; top: -115px;" class="chanpin-pic" type="flex" align="middle">
            <el-col :lg="{span:1,offset:1}" :md="{span:1,offset:1}" :sm="{span:1,offset:1}"
                    :xs="{span:1,offset:1}">
              <img style="margin-top: 30px" src="@/../static/iamges/home/home_piconl.png"
                   @click="ShowProductPic2()">
            </el-col>
            <el-col v-for="(item,index) in productPic" :key="index " :lg="{span:5,offset:1}"
                    :md="{span:5,offset:1}" :sm="{span:5,offset:1}" :xs="{span:5,offset:1}">
              <div class="product-thumbnail-container">
                <img class="img-home-p2 product-thumbnail-image"
                     :style="{ objectFit: item.fit || 'cover' }"
                     :src="item.url"
                     @load="onThumbnailImageLoad($event, item)">
              </div>
            </el-col>
            <el-col :lg="{span:1}" :md="{span:1}" :sm="{span:1}" :xs="{span:1}">
              <img style="margin-top: 30px;margin-left: 10px"
                   src="@/../static/iamges/home/home_piconr.png" @click="ShowProductPic(productPic)">
            </el-col>

          </el-row>
        </el-col>
        <!--        <el-col class="chanpin-right" :lg="{span:6,offset: 2}">-->
        <!--          <img src="@/../static/iamges/home/home_pright-1.png">-->
        <!--        </el-col>-->
        <el-col class="chanpin-right" :lg="{span:6,offset: 2}">
          <div class="feature-list">
            <div>
              <div class="feature-title">
                <div>世界首创：AI动态景深技术</div>
                <div style="font-size: 16px;">授权专利号：ZL 2021 1 1289607.2；ZL 2021 1 0900221.4</div>
                <div style="font-size: 20px;margin-top: 10px;">十年打磨：下一代显微成像技术</div>
                <div style="font-size: 20px;">更小，更快，更清晰，更智能</div>
              </div>
              <div>
                <div class="feature-item"/>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  首创掌中亚微米精度扫描仪
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  友好易用的界面
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  自动识别组织区域
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  分区域扫描跳过空白区域
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  无缝对接病理AI大模型
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  方便对接专有/自建AI模型
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  一键上传专家平台远程会诊
                </div>
                <div class="feature-item">
                  <img style="margin: 0 5px 0 0" src="@/../static/iamges/home/arrow.svg">
                  丰富的API/SDK助力病理AI推广
                </div>
              </div>
            </div>
          </div>
        </el-col>

      </el-row>
      <el-row style="margin-top: 120px;padding-bottom: 40px">
        <el-col :lg="{span:16,offset:3}" style="background-color: #f8f8f8;">

          <!--                    <el-row>-->
          <!--                        <el-col :lg="{span:6,offset:0}" style="margin-top: 20px;margin-left: -25px">-->
          <!--                            <img src="@/../static/iamges/home/home_bg_title.png">-->
          <!--                        </el-col>-->

          <!--                    </el-row>-->
          <!--                    <el-row style="padding-bottom: 10px" >-->

          <!--                        <el-col :lg="{span:6,offset:0}"-->

          <!--                                style="color: #ffffff;font-size: 20px;font-weight: 600;margin-left: -25px;position: relative; margin-top: -34px;-->
          <!--                                      text-decoration: underline #ffffff">-->
          <!--                            <div @click="gotoSlide()">-->
          <!--                                病理切片-->
          <!--                            </div>-->

          <!--                        </el-col>-->


          <!--                    </el-row>-->


          <el-row>
            <el-col :lg="{span:6,offset:0}" style="margin-top: 20px;margin-left: -25px">
              <img src="@/../static/iamges/home/home_bg_title.png">
            </el-col>

          </el-row>
          <el-row>
            <el-col :lg="{span:6,offset:0}"
                    style="color: #ffffff;font-size: 20px;font-weight: 600;margin-left: -25px;position: relative; margin-top: -34px;">
              产品概述
            </el-col>
          </el-row>
          <p style="text-align: left;padding-left:45px;line-height: 30px">
            便携式数字切片扫描仪是图灵基因自主研发的光学扫描影像设备，通过攻克超高分辨率扫描技术，采用自有知识产权的微型化结构，
            实现了自动对焦、自动扫描、自动拼接，且重量轻、体积小、便于携带，可用于远程会诊、科学研究、形态学教学及病理AI领域。</p>
          <el-row style="margin-top: -20px ">
            <el-col :lg="{span:6,offset:0}" style="margin-top: 20px;margin-left: -25px">
              <img src="@/../static/iamges/home/home_bg_title.png">
            </el-col>

          </el-row>
          <el-row>
            <el-col :lg="{span:6,offset:0}"
                    style="color: #ffffff;font-size: 20px;font-weight: 600;margin-left: -25px;position: relative; margin-top: -34px;">
              产品参数
            </el-col>
          </el-row>


          <el-row style="margin-top: 15PX">
            <el-col :lg="{span:6}" :md="{span:6}" :sm="{span:6}" :xs="{span:18 ,offset:3}"
                    class="chanpin-canshu">
              <img style="width: 90%;" src="@/../static/iamges/home/home_bg_250_80.png">
              <div style="position: relative;top: -66px;">
                <div style="font-size: 18px;color: #7b9d38">切片装载数量</div>
                <div style="font-size: 14px;">单片</div>
              </div>
            </el-col>

            <el-col :lg="{span:6}" :md="{span:6}" :sm="{span:6}" :xs="{span:18,offset:3}"
                    class="chanpin-canshu">
              <img style="width: 90%;" src="@/../static/iamges/home/home_bg_250_80.png">
              <div style="position: relative;top: -66px;">
                <div style="font-size: 18px;color: #7b9d38">物镜</div>
                <div style="font-size: 14px;">20X/40X</div>
              </div>
            </el-col>
            <el-col :lg="{span:6}" :md="{span:6}" :sm="{span:6}" :xs="{span:18,offset:3}"
                    class="chanpin-canshu">
              <img style="width: 90%;" src="@/../static/iamges/home/home_bg_250_80.png">
              <div style="position: relative;top: -66px;">
                <div style="font-size: 18px;color: #7b9d38">仪器尺寸</div>
                <div style="font-size: 14px;">130mm*110mm*130mm</div>
              </div>
            </el-col>
            <el-col :lg="{span:6}" :md="{span:6}" :sm="{span:6}" :xs="{span:18,offset:3}"
                    class="chanpin-canshu">
              <img style="width: 90%;" src="@/../static/iamges/home/home_bg_250_80.png">
              <div style="position: relative;top: -66px;">
                <div style="font-size: 18px;color: #7b9d38">仪器重量</div>
                <div style="font-size: 14px;">2.3KG</div>
              </div>
            </el-col>
          </el-row>


          <!--                    <el-row style="margin-top: 15px;border: 5px solid rgba(160,193,95,0.2);width: 93%;margin: auto">-->
          <!--                        <iframe src="http://192.168.1.195:8080/"-->
          <!--                                width="100%" height="300" frameborder="0"></iframe>-->
          <!--                    </el-row>-->

          <el-row>
            <el-col :lg="{span:6,offset:0}" style="margin-top: 30px;margin-left: -25px">
              <img src="@/../static/iamges/home/home_bg_title.png">
            </el-col>

          </el-row>
          <el-row>
            <el-col :lg="{span:6,offset:0}"
                    style="color: #ffffff;font-size: 20px;font-weight: 600;margin-left: -25px;position: relative; margin-top: -34px;">
              应用场景
            </el-col>
          </el-row>
          <el-row style="margin-top: 15px;">
            <el-col :lg="{span:8} " :md="{span:8}" :sm="{span:8}" :xs="{span:16,offset:4}">
              <el-row>
                <img class="img-pic"
                     style="width: 94%;height: 260px;border: 5px solid rgba(160,193,95,0.2)" fit="fill"
                     src="@/../static/iamges/home/linchuang.jpg">
                <img style="width: 96%;margin-top: -5px"
                     src="@/../static/iamges/home/home_bg_340_150.png">
                <div style="position: relative;width: 97%;margin-top: -120px;padding-left: 20px">
                  <div class="changjing-text" style="font-size: 16px;color: #7b9d38;text-align: left">
                    临床病理诊断
                  </div>
                  <p style="font-size: 14px;color: #555555;padding:0 30px;text-align: left;">
                    利用其建立超大容量的数字病理切片库，保存珍贵的病理切片资料，解决了玻璃切片不易储存保管、易褪色、易损坏、易丢片掉片
                    和切片检索困难等问题，并且实现了同一张切片可以再不同地点同时被很多人浏览。

                  </p>
                </div>
              </el-row>
              <el-row style="margin-top: -4px;">
                <el-col>
                </el-col>
              </el-row>
            </el-col>
            <el-col :lg="{span:8} " :md="{span:8}" :sm="{span:8}" :xs="{span:16,offset:4}">
              <el-row>
                <img class="img-pic"
                     style="width: 94%;height: 260px;border: 5px solid rgba(160,193,95,0.2)"
                     src="@/../static/iamges/home/shiyan.jpg" fit="fill">
                <img style="width: 96%;margin-top: -5px"
                     src="@/../static/iamges/home/home_bg_340_150.png">
                <div style="position: relative;width: 97%;margin-top: -120px;padding-left: 20px">
                  <div class="changjing-text" style="font-size: 16px;color: #7b9d38;text-align: left">
                    科学实验
                  </div>
                  <p style="font-size: 14px;color: #555555;padding:0 30px;text-align: left;">
                    自带AI建模和模型解释功能，有望帮助科研工作者发现更多细胞和组织空间结构规律。</p>
                </div>
              </el-row>
              <el-row style="margin-top: -4px;">
                <el-col>
                </el-col>
              </el-row>
            </el-col>
            <el-col :lg="{span:8} " :md="{span:8}" :sm="{span:8}" :xs="{span:16,offset:4}">
              <el-row>
                <img class="img-pic"
                     style="width: 94%;height: 260px;border: 5px solid rgba(160,193,95,0.2)"
                     src="@/../static/iamges/home/teaching.jpg" object-fit="cover">
                <img style="width: 96%;margin-top: -5px"
                     src="@/../static/iamges/home/home_bg_340_150.png">
                <div style="position: relative;width: 97%;margin-top: -120px;padding-left: 20px;margin-bottom: 80px">
                  <div class="changjing-text" style="font-size: 16px;color: #7b9d38;text-align: left">
                    课堂教学
                  </div>
                  <p style="font-size: 14px;color: #555555;padding:0 30px;text-align: left;">

                    小巧便携，方便课程上用电脑展示、传阅和重点圈画讲解，性价比高，形态学教学事半功倍。</p>
                </div>
              </el-row>
              <el-row style="margin-top: -4px;">
                <el-col>
                </el-col>
              </el-row>
            </el-col>


          </el-row>


        </el-col>


      </el-row>
      <!--            <el-row>-->
      <!--                <el-col :span="16" :offset="3" style="margin-bottom: 30px">-->
      <!--                    <img style="width: 100%;" src="@/../static/iamges/home/scanPurchase.jpg" >-->
      <!--                </el-col>-->
      <!--            </el-row>-->


    </div>


  </div>
</template>
<script>
export default {
  name: "Homepage",
  mounted() {
    this.$emit("handleSelect", "0", ["0"])
  },
  data() {
    return {
      pictureList: [
        // require("@/../static/iamges/1.png"),
        require("@/../static/iamges/home/bigPicture.jpg"),
        require("@/../static/iamges/sample1.png"),
        require("@/../static/iamges/sample2.png"),
        require("@/../static/iamges/sample3.jpg"),
      ],
      prodctIdx: 0,
      productPic: [
        {
          index: 0,
          url: require("@/../static/iamges/home/scan0.jpg"),
          fit: 'cover' // 默认横向图使用 cover，纵向图会在加载时改为 contain
        },
        {
          index: 1,
          url: require("@/../static/iamges/home/scan1.jpg"),
          fit: 'cover'
        },
        {
          index: 2,
          url: require("@/../static/iamges/home/scan2.jpg"),
          fit: 'cover'
        },


      ],
      currentUrl: require("@/../static/iamges/home/scan0.jpg"),
      currentImageFit: 'cover', // 主图的 object-fit 属性，默认横向图使用 cover

      contactUs: [
        {
          icon: require("@/../static/iamges/phone.png"),
          text: "18121496883"
        },
        {
          icon: require("@/../static/iamges/location.png"),
          text: "江苏省苏州市吴江区江陵街道Max科技园3栋图灵基因"
        },
        {
          icon: require("@/../static/iamges/email.png"),
          text: "product@turingene.com"
        },
        {
          icon: require("@/../static/iamges/www.png"),
          text: "www.turingene.com"
        },
      ],
      activeIndex: '1',
      menuItemStyle: [
        {backgroundColor: "#074A81", color: "#fff"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"}
      ],
      selectedKey: 0,

    }
  },
  methods: {
    handleSelect(key, keyPath) {
      console.log(key, keyPath);
      this.selectedKey = key;
      console.log(this.selectedKey);
      this.menuItemStyle = [
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"},
        {backgroundColor: "#E4E4E4", color: "#000"}
      ]
      this.menuItemStyle[key] = {backgroundColor: "#074A81", color: "#fff"}
    },
    gotoDetail() {
      this.$root.$index.handleSelect("3", ["1", "3"]);
      this.$router.push({
        path: "/productDetails"
      })
    },
    /**
     * 检测图片方向并设置合适的 object-fit 属性
     * 业务背景：产品图可能是纵向图或横向图，纵向图需要完整显示（contain），横向图保持填充（cover）
     * 设计决策：通过图片的宽高比判断方向，高度大于宽度时为纵向图，使用 contain；否则使用 cover
     * @param {HTMLImageElement} img - 图片元素
     * @param {Object} item - 图片数据对象（可选，用于更新小图）
     * @returns {string} - 返回 'contain' 或 'cover'
     */
    detectImageOrientation(img, item = null) {
      const width = img.naturalWidth || img.width;
      const height = img.naturalHeight || img.height;
      
      // 纵向图：高度大于宽度，使用 contain 保持完整显示
      // 横向图：宽度大于等于高度，使用 cover 填充容器
      const isPortrait = height > width;
      const fit = isPortrait ? 'contain' : 'cover';
      
      // 如果传入了 item 对象，更新小图的 fit 属性
      if (item) {
        item.fit = fit;
      }
      
      return fit;
    },
    
    /**
     * 主图加载完成时的处理函数
     * 业务背景：主图加载后需要检测方向并设置合适的显示方式
     * 设计决策：使用图片的 naturalWidth 和 naturalHeight 获取真实尺寸进行判断
     * @param {Event} event - 图片加载事件
     */
    onMainImageLoad(event) {
      const img = event.target;
      this.currentImageFit = this.detectImageOrientation(img);
    },
    
    /**
     * 缩略图加载完成时的处理函数
     * 业务背景：缩略图加载后需要检测方向并设置合适的显示方式
     * 设计决策：通过 item 参数更新对应图片的 fit 属性，触发响应式更新
     * @param {Event} event - 图片加载事件
     * @param {Object} item - 图片数据对象
     */
    onThumbnailImageLoad(event, item) {
      const img = event.target;
      this.detectImageOrientation(img, item);
    },
    
    ShowProductPic2() {
      this.prodctIdx--;
      if (this.prodctIdx < 0) {
        this.prodctIdx = 2
      }
      this.currentUrl = require("@/../static/iamges/home/scan" + this.prodctIdx + ".jpg")
      // 重置主图的 fit 属性，等待新图片加载后重新检测
      this.currentImageFit = 'cover';

    },
    gotoSlide() {
      console.log(2222)
      this.$router.push({
        query: {
          id: 3,
          page: 0
        },
        path: "/slideShow"
      })
    },
    ShowProductPic() {
      console.log(11111);
      this.prodctIdx++;
      if (this.prodctIdx > 2) {
        this.prodctIdx = 0
      }
      this.currentUrl = require("@/../static/iamges/home/scan" + this.prodctIdx + ".jpg")
      // 重置主图的 fit 属性，等待新图片加载后重新检测
      this.currentImageFit = 'cover';

    },
  }
}
</script>

<style scoped lang="css">
/*<!--    屏幕宽度小于992px-->*/
@media only screen and (max-width: 992px) {
  .homePage {
  }

  .el-carousel >>> .el-carousel__container {
    height: 100px;
  }
  
  .el-carousel >>> .el-carousel__item {
    height: 100%;
  }

  .carousel-img >>> img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: top;
  }
  
  .carousel-img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  .carousel-img >>> .el-image__inner {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: top !important;
  }

}

/* 产品主图容器 - 使用 aspect-ratio 保持固定宽高比，响应式适配 */
.product-main-image-container {
  width: 98%;
  aspect-ratio: 4 / 3; /* 保持 4:3 的宽高比，可根据实际需求调整 */
  position: relative;
  border: 5px solid rgba(160, 193, 95, 0.2);
  overflow: hidden;
  margin-bottom: 10px; /* 与缩略图区域保持 10px 外边距，保证视觉间距一致 */
}

/* 产品主图 - 填充容器并保持宽高比 */
.product-main-image {
  width: 100%;
  height: 100%;
  display: block;
}

/* 产品缩略图容器 - 使用 aspect-ratio 保持固定宽高比 */
.product-thumbnail-container {
  width: 88%;
  aspect-ratio: 4 / 3; /* 保持 4:3 的宽高比，可根据实际需求调整 */
  position: relative;
  border: 4px solid rgba(160, 193, 95, 0.2);
  overflow: hidden;
  margin-left: 5px;
  /* 与主图容器保持 10px 外边距 */
  /* margin-top: 10px;  */
}

/* 产品缩略图 - 填充容器并保持宽高比 */
.product-thumbnail-image {
  width: 100%;
  height: 100%;
  display: block;
}

.chanpin-pic >>> .img-home-p2 {
  margin-top: 0;
  margin-left: 0;
}

/*屏幕宽度<768px*/
@media only screen and (max-width: 768px) {
  .el-carousel >>> .el-carousel__container {
    height: 100px;
  }
  
  .el-carousel >>> .el-carousel__item {
    height: 100%;
  }

  .carousel-img >>> img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
    object-position: top !important;
  }
  
  .carousel-img {
    width: 100%;
    height: 100%;
    display: block;
  }
  
  .carousel-img >>> .el-image__inner {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    object-position: top !important;
  }

}

/*屏幕宽度大于768px*/
@media only screen and (min-width: 768px) {
  .el-carousel >>> .el-carousel__container {
    height: 400px;
  }
  
  .el-carousel >>> .el-carousel__item {
    height: 100%;
  }

  .carousel-img >>> img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
    object-position: top !important;
  }
  
  .carousel-img {
    width: 100%;
    height: 100%;
  }


}

/*屏幕宽度大于992px*/
@media only screen and (min-width: 992px) {

  .el-carousel >>> .el-carousel__container {
    height: 500px;
  }
  
  .el-carousel >>> .el-carousel__item {
    height: 100%;
  }

  .carousel-img >>> img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
    object-position: top !important;
  }
  
  .carousel-img {
    width: 100%;
    height: 100%;
  }


  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 150px;
    margin: 0;
  }
}

@media only screen and (min-width: 1200px) {
  .chanpin-pic >>> .img-home-p2 {
    margin-top: 0;

  }
  
  /* 大屏幕下保持缩略图容器外边距为 10px */
  .product-thumbnail-container {
    margin-top: 10px;
  }

  .el-carousel >>> .el-carousel__item {
    height: 100%;
  }

  .carousel-img >>> img {
    width: 100%;
    height: 100%;
    object-fit: cover !important;
    object-position: top !important;
  }
  
  .carousel-img {
    width: 100%;
    height: 100%;
  }
}

/*屏幕宽度大于1550px*/
/*@media only screen and (min-width: 1550px) {*/
/*    .chanpin-canshu {*/
/*        display: flex;*/
/*        align-items: center; */
/*        justify-content: space-evenly;*/
/*    }*/
/*}*/

/*小于768*/
@media only screen and (max-width: 768px) {
  .chanpin-pic >>> .img-home-p2 {
    margin-top: 0;
    margin-left: 0;
  }
  
  /* 小屏幕下调整缩略图容器边距 */
  .product-thumbnail-container {
    margin-top: 10px;
    margin-left: 10px;
  }

  .changjing-text {
    margin-top: 40px !important;
  }

  /*.img-pic{*/
  /*    object-fit: cover;*/
  /*}*/

}

/*小于480*/
@media only screen and (max-width: 480px) {
  .chanpin-pic >>> .img-home-p2 {
    margin-top: 0;

  }
  
  /* 超小屏幕下保持缩略图容器外边距为 10px */
  .product-thumbnail-container {
    margin-top: 10px;
  }
}

.img-pic {
  object-fit: cover;
}


.feature-list {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  text-align: justify;
  padding: 0 5px 0 5px;
}

.feature-title {
  font-size: 28px;
  font-weight: bold;
  color: #A0C15F;
  margin-bottom: 10px; /* 添加一些间距 */
}

.feature-item {
  display: flex; /* 使用Flexbox布局 */
  align-items: flex-start; /* 垂直居中对齐 */
  margin: 10px 0 20px -20px; /* 调整间距 */
  font-size: 18px;
}

.feature-item i {
  width: 15px; /* 圆形项目符号的宽度 */
  height: 15px; /* 圆形项目符号的高度 */
  background-color: #E5EBD7; /* 圆形项目符号的颜色 */
  border-radius: 50%; /* 圆形效果 */
  display: inline-block; /* 使i元素作为块级元素显示 */
  margin-right: 10px; /* 与文本保持一定间距 */
  font-style: normal; /* 移除斜体样式 */
}

.feature-item span {
  font-size: inherit; /* 确保span内的字体大小与外部一致 */
  color: inherit; /* 确保span内的颜色与外部一致 */
  font-style: italic; /* 仅使span内的文本斜体 */
}

.feature-item {
  position: relative;
  padding-left: 20px;
  margin-bottom: 10px;
  text-align: justify;
}

.feature-item i {
  position: absolute;
  left: 0;
  top: 0;
  width: 10px;
  height: 10px;
  background-color: black;
  border-radius: 50%;
  display: inline-block;
}
</style>
